import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "./store"
import { turnAnswered } from "./agentTurnActions"

type RttEntry = {
  text: string
  seq: number
}

export type RttState = Record<string, RttEntry | undefined>

const initialState: RttState = {}

const rttSlice = createSlice({
  name: "rtt",
  initialState,
  reducers: {
    rttNew: {
      reducer: (
        state,
        action: PayloadAction<{ roomJid: string; text: string; at: number }>,
      ) => {
        state[action.payload.roomJid] = { text: action.payload.text, seq: 0 }
      },
      // Stamped here so the agent turn it may open keeps a pure reducer.
      prepare: (payload: { roomJid: string; text: string }) => ({
        payload: { ...payload, at: Date.now() },
      }),
    },
    rttAppend: (
      state,
      action: PayloadAction<{ roomJid: string; text: string; seq: number }>,
    ) => {
      const existing = state[action.payload.roomJid]
      if (existing) {
        existing.text += action.payload.text
        existing.seq = action.payload.seq
      } else {
        state[action.payload.roomJid] = {
          text: action.payload.text,
          seq: action.payload.seq,
        }
      }
    },
    rttReset: (
      state,
      action: PayloadAction<{ roomJid: string; text: string; seq: number }>,
    ) => {
      state[action.payload.roomJid] = {
        text: action.payload.text,
        seq: action.payload.seq,
      }
    },
  },
  extraReducers: (builder) => {
    // The answer's body supersedes the streamed draft.
    builder.addCase(turnAnswered, (state, action) => {
      delete state[action.payload.roomJid]
    })
  },
})

export const { rttNew, rttAppend, rttReset } = rttSlice.actions
export default rttSlice.reducer

export const selectRttText = (
  state: RootState,
  roomJid: string,
): string | undefined => state.rtt?.[roomJid]?.text
